import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { isDate } from "rxjs/util/isDate";

import {
    materialTitle, materialStorageName, materialCodigoMask
} from "../shared/data.service";
import { MaterialService } from "../shared/material.service";
import { AutoCompleteService } from "../../../../shared/components/autocomplete/autocomplete.service";
import { UtilService } from "../../../../shared/services/util.service";
import { newRoute, editRoute } from "../../../../shared/services/data.service";
import {Medida} from "../../../medidas/shared/medida.model";
import {ContaContabil} from "../../../../contas/conta-contabil/shared/conta-contabil.model";
import {GrupoMaterial} from "../../../grupos-materiais/shared/grupo-material.model";
import {gruposQuery, gruposMateriaisStorage} from "../../../grupos-materiais/shared/data.service";
import {contasContabeisQuery, contasContabeisStorage} from "../../../../contas/conta-contabil/shared/data.service";
import {medidasQuery, medidasStorage} from "../../../medidas/shared/data.service";
import {GrupoMaterialApiService} from "../../../grupos-materiais/shared/grupo-material-api.service";
import {GrupoMaterialNavigationService} from "../../../grupos-materiais/shared/grupo-material-navigation.service";
import {GrupoMaterialService} from "../../../grupos-materiais/shared/grupo-material.service";
import {ContaContabilApiService} from "../../../../contas/conta-contabil/shared/conta-contabil-api.service";
import {ContaContabilService} from "../../../../contas/conta-contabil/shared/conta-contabil.service";
import {ContaContabilNavigationService} from "../../../../contas/conta-contabil/shared/conta-contabil-navigation.service";
import {MedidaApiService} from "../../../medidas/shared/medida-api.service";
import {MedidaNavigationService} from "../../../medidas/shared/medida-navigation.service";
import {MedidaService} from "../../../medidas/shared/medida.service";
import {MaterialTipoApiService} from "../material-tipos/shared/material-tipo-api.service";

declare var swal: any;

@Component({
    template: require('./material-form.component.html')
})

export class MaterialFormComponent implements OnInit {
    actionTitle: string;
    materialTitle: any = materialTitle;
    btnSalveDisabled: boolean = false;
    types: Array<any> = [];
    classificacaoCodigo: string = '';
    materialCodigoMask: number = materialCodigoMask;
    submitted: boolean = false;
    medidaObject: any = new Medida();
    contaContabilObject: any = new ContaContabil();
    grupoObject: any = new GrupoMaterial();
    subgrupoObject: any = new GrupoMaterial();
    formObject: any = {};

    formMaterial: FormGroup;
    id: FormControl;
    tipo: FormControl;
    grupo: FormControl;
    subgrupo: FormControl;
    descricao: FormControl;
    descricaoCompleta: FormControl;
    contaContabil: FormControl;
    contaContabilConsumo: FormControl;
    medida: FormControl;
    dataCriacao: FormControl;
    ativo: FormControl;
    controlaValidade: FormControl;
    exigeMarca: FormControl;
    mantemEstoque: FormControl;
    inventariavel: FormControl;
    classificacao: FormControl;

    grupoSelectId: string = 'material_grupo';
    grupoQuery: any;

    subgrupoSelectId: string = 'material_subgrupo';
    subgrupoQuery: any;

    contaContabilSelectId: string = 'material_contacontabil_consumo';
    contaContabilConsumoText: string = '';
    contaContabilQuery: any;

    medidaSelectId: string = 'material_medida';
    medidaQuery: any = medidasQuery;

    private hasSession:boolean = false;
    private contaContabilTipo: number;
    private materialModule: string = materialStorageName;
    private returnToOtherForm: boolean = false;
    private otherForm: string = "";
    private responseMaterial: any;

    constructor(
        private _materialService: MaterialService,
        private _grupoMaterialApiService: GrupoMaterialApiService,
        private _grupoMaterialNavigationService: GrupoMaterialNavigationService,
        private _grupoMaterialService: GrupoMaterialService,
        private _contaContabilApiService: ContaContabilApiService,
        private _contaContabilService: ContaContabilService,
        private _contaContabilNavigationService: ContaContabilNavigationService,
        private _medidaApiService: MedidaApiService,
        private _medidaNavigationService: MedidaNavigationService,
        private _materialTipoApiService: MaterialTipoApiService,
        private _medidaService: MedidaService,
        private _autocompleteService: AutoCompleteService,
        private _utilService: UtilService,
        private _route: ActivatedRoute,

        private builder: FormBuilder
    ){
        this.id = new FormControl({value: '', disabled: true});
        this.descricao = new FormControl('', Validators.required);
        this.tipo = new FormControl();
        this.grupo = new FormControl('', Validators.required);
        this.subgrupo = new FormControl('', Validators.required);
        this.descricaoCompleta = new FormControl('', Validators.required);
        this.contaContabil = new FormControl('', Validators.required);
        this.contaContabilConsumo = new FormControl({value: '', disabled: true});
        this.medida = new FormControl('', Validators.required);
        this.dataCriacao = new FormControl({value: '', disabled: true}, Validators.required);
        this.ativo = new FormControl();
        this.controlaValidade = new FormControl();
        this.exigeMarca = new FormControl();
        this.mantemEstoque = new FormControl();
        this.inventariavel = new FormControl();
        this.classificacao = new FormControl({value: '', disabled: true});
        this.formMaterial = builder.group({
            ativo: this.ativo,
            id: this.id,
            descricao: this.descricao,
            tipo: this.tipo,
            grupo: this.grupo,
            subgrupo: this.subgrupo,
            descricaoCompleta: this.descricaoCompleta,
            contaContabil: this.contaContabil,
            contaContabilConsumo: this.contaContabilConsumo,
            medida: this.medida,
            dataCriacao: this.dataCriacao,
            controlaValidade: this.controlaValidade,
            exigeMarca: this.exigeMarca,
            mantemEstoque: this.mantemEstoque,
            inventariavel: this.inventariavel,
            classificacao: this.classificacao
        });
    }

    ngOnInit() {
        this.getTiposMateriais();
        this.contaContabilQuery = this._utilService.cloneObject(contasContabeisQuery);
        this.grupoQuery = this._utilService.cloneObject(gruposQuery);
        this.subgrupoQuery = this._utilService.cloneObject(gruposQuery);
        this.contaContabilTipo = this._contaContabilService.getTipoConsumo();
        this.contaContabilQuery.where.tipoId = this.contaContabilTipo;
        this.grupoQuery.where.codigoGrupo = null;
        this.isNewAutoComplete();
        document.getElementById("material_descricao").focus();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        var date: any = null;
        date = document.getElementById("material_data_cadastro");
        if (date.value) {
            this.setSelectOnFormControl('dataCriacao', date, 'value');
        }

        if(evt.valid) {
            this.btnSalveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.grupoObject && this.subgrupoObject) {
                object.grupoMaterialId = this.subgrupoObject.id;
            }

            if (this.contaContabilObject) {
                object.contaContabilId = this.contaContabilObject.id;
            }

            if (this.medidaObject) {
                object.medidaId = this.medidaObject.id;
            }

            if (!object.controlaValidade) object.controlaValidade = false;
            if (!object.exigeMarca) object.exigeMarca = false;
            if (!object.mantemEstoque) object.mantemEstoque = false;
            if (!object.inventariavel) object.inventariavel = false;

            object.dataCriacao = this._utilService.convertStringToDate(date.value);

            delete object['contaContabil'];
            delete object['medida'];
            delete object['grupo'];
            delete object['subgrupo'];
            delete object['dataCriacao'];
            delete object['dataUltimaAlteracao'];
            delete object['usuarioCriacaoId'];
            delete object['usuarioUltimaAlteracaoId'];
            delete object['tipo'];

            if (object.id) {
                this.onEditMaterial(object);
            } else {
                this.onSaveMaterial(object);
            }
        }
    }

    onCheckType(selectedItem: any) {
        this.formObject.tipoId = selectedItem;
        setTimeout(function() {
            var tt: any = document.getElementById("type_"+selectedItem);
            if (tt) {
                tt.checked = true;
            }
        });
    }

    clickGoToList() {
        this.toLeaveHere();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    //grupo
    onGetGrupoObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();
            this._materialService.setSessionStorage(thisFormObject);

            var objectModel: any = {descricao: object.text, novo: true, form: materialStorageName};
            this._autocompleteService.setSessionStorage(objectModel, gruposMateriaisStorage);
            this._grupoMaterialNavigationService.goToNew();
        } else {
            this.grupoObject = object;
            this.setSelectOnFormControl('grupo', object);
            this.onSetGrupoSeleted();
        }
    }

    onSetGrupoSeleted() {
        if (this.subgrupoQuery) {
            this.subgrupoQuery.where.grupoId = this.grupoObject.id;
        } else {
            this.subgrupoQuery = {where: {grupoId: this.grupoObject.id}};
        }
    }

    onGetSubgrupoObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();
            this._materialService.setSessionStorage(thisFormObject);

            var descricao: string = (this.grupoObject.descricao) ? this.grupoObject.descricao: this.grupoObject.text;
            var grupo: any = {id: this.grupoObject.id, descricao: descricao};
            var objectModel: any = {grupo: grupo, descricao: object.text, novo: true, form: materialStorageName};
            this._autocompleteService.setSessionStorage(objectModel, gruposMateriaisStorage);
            this._grupoMaterialNavigationService.goToAddSubgrupo(grupo.id);
        } else {
            this.subgrupoObject = object;
            this.setSelectOnFormControl('subgrupo', object);
            this.setContaContabilLabel(object.contaContabil);
        }
    }

    //conta contabil
    onGetContaContabilObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();
            this._materialService.setSessionStorage(thisFormObject);

            var objectModel: any = {
                descricao: object.text,
                tipoId: this.contaContabilTipo,
                descricaoAnalitica: true,
                novo: true,
                form: materialStorageName
            };
            this._autocompleteService.setSessionStorage(objectModel, contasContabeisStorage);
            this._contaContabilNavigationService.goToNew();
        } else {
            this.contaContabilObject = object;
            this.setSelectOnFormControl('contaContabil', object);
        }
    }

    //medida
    onGetMedidaObject(object: any) {
        if(object.novo) {
            this._materialService.setSessionStorage(this.formObject);

            var objectModel: any = {medida: object.text, novo: true, form: materialStorageName};
            this._autocompleteService.setSessionStorage(objectModel, medidasStorage);
            this._medidaNavigationService.goToNew();
        } else {
            this.medidaObject = object;
            this.setSelectOnFormControl('medida', object);
        }
    }

    grupoTemplateResult = (function (state: any) {
        var template: any = this._grupoMaterialService.templateResult(state, true);
        return template;
    }.bind(this));

    contaContabilTemplateResult = (function(state: any) {
        var template: any = this._contaContabilService.templateResult(state, true);
        return template;
    }.bind(this));

    private setObjectBeforeLeave() {
        var object:any = this.formObject;
        object.contaContabil = this.contaContabilObject;
        object.grupoMaterial = this.grupoObject;
        object.subgrupo = this.subgrupoObject;
        object.medida = this.medidaObject;

        return object;
    }

    private setContaContabilLabel(object: any) {
        if (object) {
            this.contaContabilConsumoText = object.codigo + " - " + object.descricao;
        }
    }

    private onSaveMaterial(objeto: any) {
        this._materialService.onPost(objeto, this.onDone);
    }

    private onEditMaterial(objeto: any) {
        this._materialService.onPut(objeto, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error) {
            this.responseMaterial = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(materialStorageName);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.descricao = newAutoComplete.descricao;

            this.setActionTitle(this.formObject.id);
            this.toFormatFormCommon();
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private testSession() {
        var id: number;
        var session: any = this._materialService.getSessionStorage();

        if (session) {
            this.hasSession = true;
            this.formObject = session;
            id = session.id;
            this.toFormatFormCommon();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.getObject(id);
            } else {
                this.toFormatFormAdd();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setSelectOnFormControl(item: string, object: any, arg?:string) {
        var tt: any = this.formMaterial.controls[item];
        if (arg) {
            tt.patchValue(object[arg]);
        } else {
            tt.patchValue(object.id);
        }
    }

    //se edicao
    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                this.formObject = Response;
                this.toFormatFormEdit();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum material encontrado com este id.');
            }
        }.bind(this));

        this._materialService.onGetById(id, onDone);
    }

    private toFormatFormEdit() {
        this.subgrupoObject = this._utilService.cloneObject(this.formObject.grupoMaterial);
        this.grupoObject = this._utilService.cloneObject(this.subgrupoObject.grupo);
        this.formObject.grupoMaterial = this.grupoObject;
        this.formObject.subgrupo = this.subgrupoObject;

        var object: any = this._utilService.cloneObject(this.formObject);
        object.grupo = this.grupoObject;
        object.subgrupo = this.subgrupoObject;

        this.classificacaoCodigo = this._materialService.getClassificacao(object);

        this.onCheckType(this.formObject.tipoId);

        this.toFormatFormCommon();
    }

    private toFormatFormAdd() {
        this.toFormatFormCommon();
    }

    private toFormatFormCommon() {
        if (this.hasSession) {
            var object: any;
            object = this._grupoMaterialService.getSessionStorage();
            if (object) {
                if (object.grupoId) {
                    this.subgrupoObject = object;
                } else {
                    this.grupoObject = object;
                }
            }

            object = this._contaContabilService.getSessionStorage();
            if (object) {
                this.contaContabilObject = object;
            }

            object = this._medidaService.getSessionStorage();
            if (object) {
                this.medidaObject = object;
            }

            this._autocompleteService.clearSessionStorage(contasContabeisStorage);
            this._autocompleteService.clearSessionStorage(gruposMateriaisStorage);
            this._autocompleteService.clearSessionStorage(medidasStorage);
            this._contaContabilService.clearSessionStorage();
            this._grupoMaterialService.clearSessionStorage();
            this._medidaService.clearSessionStorage();
        }

        if (this.formObject.grupoMaterial){
            this.grupoObject = this.formObject.grupoMaterial;
            delete this.formObject['grupoMaterial'];

            if (this.grupoObject && this.grupoObject.descricao) {
                this.grupoObject = {text: this.grupoObject.codigo + " - " + this.grupoObject.descricao, id: this.grupoObject.id};
            }

            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.grupoSelectId, this.grupoObject);
                this._autocompleteService.setValueOnSelect2(this.grupoObject.id, this.grupoSelectId);
            }.bind(this));
            this.setSelectOnFormControl('grupo', this.grupoObject);
            this.onSetGrupoSeleted();
        }

        if (this.formObject.subgrupo){
            this.subgrupoObject = this.formObject.subgrupo;
            delete this.formObject['subgrupo'];

            this.setContaContabilLabel(this.subgrupoObject.contaContabil);
            if (this.subgrupoObject && this.subgrupoObject.descricao) {
                this.subgrupoObject = {text: this.subgrupoObject.codigoGrupo + ' - ' + this.subgrupoObject.descricao, id: this.subgrupoObject.id};
            }

            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.subgrupoSelectId, this.subgrupoObject);
                this._autocompleteService.setValueOnSelect2(this.subgrupoObject.id, this.subgrupoSelectId);
            }.bind(this));
            this.setSelectOnFormControl('subgrupo', this.subgrupoObject);
        }

        if (this.formObject.contaContabil){
            this.contaContabilObject = this.formObject.contaContabil;
            delete this.formObject['contaContabil'];

            if (this.contaContabilObject && this.contaContabilObject.descricao) {
                this.contaContabilObject = {text: this.contaContabilObject.codigo + ' - ' + this.contaContabilObject.descricao, id: this.contaContabilObject.id};
            }

            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, this.contaContabilObject);
                this._autocompleteService.setValueOnSelect2(this.contaContabilObject.id, this.contaContabilSelectId);
            }.bind(this));
            this.setSelectOnFormControl('contaContabil', this.contaContabilObject);
        }

        if (this.formObject.medida){
            this.medidaObject = this.formObject.medida;
            delete this.formObject['medida'];

            if (this.medidaObject && this.medidaObject.medida) {
                this.medidaObject = {text: this.medidaObject.medida, id: this.medidaObject.id};
            }
            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.medidaSelectId, this.medidaObject);
                this._autocompleteService.setValueOnSelect2(this.medidaObject.id, this.medidaSelectId);
            }.bind(this));
            this.setSelectOnFormControl('medida', this.medidaObject);
        }

        var date: any = (this.formObject.dataCriacao) ? this.formObject.dataCriacao : new Date();
        date = new Date(date);
        if (isDate(date)) {
            this.formObject.dataCriacao =  this._utilService.convertDateToString(date);
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._materialService.returnToOtherForm(this.otherForm, this.responseMaterial);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._materialService.goToList();
    }

    private getTiposMateriais() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.types = Response;
                this.onCheckType(this.types[1].id);
            }
        }.bind(this));

        this._materialTipoApiService.onGetAll(onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material-form/material-form.component.ts
 **/